/*
 * @Auther: qinzhenhao
 * @Date: 2022-12-26 11:15:15
 * @LastEditors: qinzhenhao
 * @LastEditTime: 2023-01-03 18:33:10
 * @Description: 
 */
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    downloadMesShow:false,//下载弹框
    downloadName:"",//下载软件，名称
    type:0 //1为手机商店，2为平板应用，3为办公应用
  },
  mutations: {
    // 显示下载弹窗
    CHANGE_SHOW (state, payload) {
        state.downloadMesShow = true
    },
    // 关闭下载弹窗
    CLOSE_MES(state, payload){
      state.downloadMesShow = false
    },
    // 改变下载软件名称
    CHANGE_DOWNLOADNAME(state, payload){
      state.downloadName = payload
    },
    // 改变下载软件所属大类
    CHANGE_TYPE (state, payload) {
      state.type = payload
    },
  },
  actions: {
  },
  modules: {
  }
})
